
export const apiRoutes = {
    root: {
        path: "/",
        method: "GET"
    },
    login: {
        path: "/user/login",
        method: "POST"
    },
    getServices: {
        path: "/user/services",
        method: "POST"
    },
    getPlans: {
        path: "/user/plans",
        method: "POST"
    },
    getPaymentWays: {
        path: "/paymentsWay/available",
        method: "GET"
    },
    getBanks: {
        path: "/banks",
        method: "GET"
    },
    generatePaymentLink: {
        path: "/paymentsWay/generateLink",
        method: "POST"
    },
    generateInstalationLink: {
        path: "/paymentsWay/generateInstallationLink",
        method: "POST"
    },
    newCustomer: {
        path: "/user/customer/new",
        method: "POST"
    },
    techGet:{
        path:"/user/tech/get",
        method:"POST"
    },
    coverageList:{
        path:"/user/coverage/list",
        method:"POST"
    },
    //#region CWMP
    cwmpGetDeviceParams:{
        method:"POST",
        path:"/user/cwmp/getdeviceparams"
    },
    cwmpRequestDeviceParams:{
        path:"/user/cwmp/requestdeviceparams",
        method:"POST"
    },
    cwmpSetDeviceParams:{
        method:"POST",  
        path:"/user/cwmp/setdeviceparams"
    },

    //#region Security
    generateSecurityCode:{
        method:"POST",
        path:"/user/security/sendcode"
    },
    verifySecurityCode:{
        method:"POST",
        path:"/user/security/verifycode"
    }  


} as const satisfies Record<string, { path: string; method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "HEAD" | "OPTIONS"; }>;